export default __webpack_public_path__ + "static/media/aura.6a9ae19b.webp";